import {defineMessages} from 'react-intl';

export const messages = defineMessages({
  sendError: {
    id: 'conversations_ui.conversation.log.sendError',
    description: 'Error when there is an issue attempting to a send a message',
    defaultMessage:
      'There was an issue sending your message. Please check your internet connection and try again.',
  },
  fileTypeError: {
    id: 'conversations_ui.conversation.log.fileTypeError',
    description:
      'Error when there is an issue attempting to a send a file due to its type. The "mimetypes" variable will be a comma separated list of file types, for example "jpg, png, pdf"',
    defaultMessage:
      'The file type you selected is not supported. Please upload one of the following: {mimetypes}.',
  },
  fileSizeError: {
    id: 'conversations_ui.conversation.log.fileSizeError',
    description:
      'Error when there is an issue attempting to a send a file due to its size. The "maxFileSize" will be a file size, for example 32 MB',
    defaultMessage:
      'The file you selected is too large. Please upload a file smaller than {maxFileSize}.',
  },
  viewOriginalCta: {
    id: 'conversations_ui.conversation.log.viewOriginalCta',
    description:
      'Label for a button that allows the user to view the original message instead of translated one',
    defaultMessage: 'View original',
  },
  translateCta: {
    id: 'conversations_ui.conversation.log.translateCta',
    description:
      'Label for a button that allows the user to translate a message',
    defaultMessage: 'Translate',
  },
  contactAnAgent: {
    id: 'conversations_ui.conversation.log.contactAnAgent',
    description: 'Title for topic selector card',
    defaultMessage: 'Contact an agent',
  },
});
